import { nanoid } from 'nanoid'
import { type IRemoveTagCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IAddTagContentData } from 'widgets/TemplateActions/ui/AddTagContent/AddTagContent.tsx'

export const createRemoveTagCallingAction = (
  data: IAddTagContentData,
  token_id?: string
): IRemoveTagCallingActionPayload => {
  return {
    action_type: 'remove_tag',
    trigger_type: 'end_of_call',
    settings: {
      token_id: token_id ?? nanoid(),
      ...data,
    },
  }
}
